// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"89":"6bcbc384","504":"2a132fb2","613":"7b42281a"}[chunkId] + ".css";
};